import ISensorDataChartState from "../models/ISensorDataChartState";

export const initialState: ISensorDataChartState = {
    sensorDataChartList: {
        datas: null,
        error: null,
        loading: false,
        success: false
    },

    sensorDataChart: {
        data: null,
        error: null,
        loading: false,
        success: false
    },
};
